import api from './api';

export const getList = async email => {
    const response = await api.request({
        method: 'get',
        url: '/cuf/list',
        params: {
            email
        }
    });
    return response.data;
};

export const getVerificationHistory = async symbol => {
    const response = await api.request({
        method: 'get',
        url: '/cuf/verification/history',
        params: {
            symbol
        }
    });
    return response.data;
};

export const getApplication = async (params, signal) => {
    const response = await api.request({
        method: 'get',
        url: `/cuf/application`,
        params,
        signal
    });

    return response.data;
};

export const getCurrentProfile = async (params, signal) => {
    const response = await api.request({
        method: 'get',
        url: `/cuf/company/current`,
        params,
        signal
    });
    return response.data;
};

export const createCuf = async params => {
    const response = await api.request({
        method: 'post',
        url: `/cuf/create`,
        params
    });
    return response.data;
};

export const cancelCuf = async params => {
    const response = await api.request({
        method: 'post',
        url: `/cuf/cancel`,
        params
    });
    return response.data;
};

export const reopenCuf = async params => {
    const response = await api.request({
        method: 'post',
        url: `/cuf/reopen`,
        params
    });
    return response.data;
};

export const saveCuf = async data => {
    const response = await api.request({
        method: 'post',
        url: `/cuf/save`,
        data
    });
    return response.data;
};

export const submitCuf = async data => {
    const response = await api.request({
        method: 'post',
        url: `/cuf/submit`,
        data
    });
    return response.data;
};

export const helpCuf = async data => {
    const response = await api.request({
        method: 'post',
        url: `/cuf/help`,
        data
    });
    return response.data;
};
